<template>
  <div class="content">
    <div class="MB-20">
      <div class="content-item_info flex-row-between">
        <div class="content-item flex-w__2">
          <div class="content-item__title">
            <div class="title">
              昨日运营数据
            </div>
          </div>
          <div class="flex-row-start content-item_info text-16">
            <div class="content-item__info-item flex-w__1 text-center">
              <p>下载</p>
              <div class="text-18 text-bold MT-20">{{ dataSet.down }}</div>
            </div>
            <div class="content-item__info-item flex-w__1 text-center">
              <p>新用户</p>
              <div class="text-18 text-bold MT-20">{{ dataSet.new_user }}</div>
            </div>
            <div class="content-item__info-item flex-w__1 text-center">
              <p>日活（DAU）</p>
              <div class="text-18 text-bold MT-20">{{ dataSet.dau }}</div>
            </div>
            <div class="content-item__info-item flex-w__1 text-center">
              <p>启动次数</p>
              <div class="text-18 text-bold MT-20">
                {{ dataSet.start_number }}
              </div>
            </div>
            <div class="content-item__info-item flex-w__1 text-center">
              <p>留存率</p>
              <div class="text-18 text-bold MT-20">{{ dataSet.dru_rate }}</div>
            </div>
            <div class="content-item__info-item flex-w__1 text-center">
              <p>注册用户</p>
              <div class="text-18 text-bold MT-20">
                {{ dataSet.register_user }}
              </div>
            </div>
          </div>
        </div>

        <!-- <t-space direction="vertical">
    <t-date-range-picker mode="week" @pick="pick" clearable allow-input/>
  </t-space> -->

        <!-- <div class="content-item flex-w__1 ML-20">
            <div class="content-item__title">
                <div class="title">
                    上月运营数据
                </div>
            </div>
            <div class="flex-row-start content-item_info text-16">
                <div class="content-item__info-item flex-w__1 text-center">
                    <p>月留存</p>
                    <div class="text-18 text-bold MT-20">{{dataSet.mru}}</div>
                </div>
                <div class="content-item__info-item flex-w__1 text-center">
                    <p>月活</p>
                    <div class="text-18 text-bold MT-20">{{dataSet.mau}}</div>
                </div>
            </div>
        </div> -->
      </div>
    </div>
    <div class="MB-20" style="position:relative">
      <div class="content-item">
        <div class="content-item__title flex-row-between">
          <div class="content-item__title-left flex-row-start">
            <el-select
              v-model="activeType"
              class="MR-20"
              placeholder="请选择数据类型"
              @change="refreshPageDate"
              @visible-change="showWeekPickerBox=false"
              size="small"
            >
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>

            <el-select
              v-model="timeType"
              class="MR-20"
              placeholder="请选择数据类型"
              @change="changeDM"
              @visible-change="showWeekPickerBox=false"
              size="small"
            >
              <el-option
                v-for="item in timeTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>

            <el-date-picker
              v-if="!showWeek"
              v-model="date"
              :type="dateSeletd"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              :clearable="false"
              @change="refreshPageDate"
              size="small"
            >
            </el-date-picker>
            <div v-if="showWeek">
              <div class="weekPicker" @click="openWeekPicker">
                <img
                  style="margin-left:5px;margin-right:10px"
                  src="~@/assets/images/time.png"
                />
                <div v-if="weekLable.length==1">{{weekLable[0]}}</div>
                <div v-else>{{weekLable[0]}}-{{weekLable[weekLable.length-1]}}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-item_info content-item__echarts flex-row-start"
          ref="echarts"
        ></div>
      </div>
               <div v-if="showWeekPickerBox" class="weekPickerBox">
                <div class="leftBox">
                  <!-- <div style="cursor: pointer">不限</div> -->
                  <div style="cursor: pointer" @click="quickChose(1)">上周</div>
                  <div style="cursor: pointer" @click="quickChose(3)">近3周</div>
                  <div style="cursor: pointer" @click="quickChose(12)">近12周</div>
                </div>
                <div class="rightBox ">
                  <div class="year">
                    <img
                      class="shuangarrow"
                      @click="changeDate('decreaseYear')"
                      src="~@/assets/images/shuang-arrow.png"
                    />
                    <img
                      class="arrow"
                      @click="changeDate('decreaseMonth')"
                      src="~@/assets/images/arrow.png"
                    />
                    <div class="yearmonth">{{ year }}年{{ month }}月</div>
                    <img
                      class="arrow"
                      @click="changeDate('increaseMonth')"
                      src="~@/assets/images/arrow-right.png"
                    />
                    <img
                      class="shuangarrow"
                      @click="changeDate('increaseYear')"
                      src="~@/assets/images/shuang-arrow-right.png"
                    />
                  </div>
                  <div class="week">
                    <div
                      v-for="(item, index) in weekArray"
                      :class="item.active ? 'activeWeek' : 'weekArray'"
                      :key="index"
                      @click="chooseWeek(index)"
                    >
                      第{{ index + 1 }}周
                    </div>
                  </div>
                  <el-button @click="refreshPageDate()" size="small" style="margin:10px 10px 0 10px">确定</el-button>
                  <el-button type="info" plain size="small" @click="showWeekPickerBox=false">取消</el-button>
                </div>
              </div>
      <el-table
        border
        :data="tableData"
        id="table"
        size="small"
        header-row-class-name="table-header"
      >
        <el-table-column
          align="center"
          label="日期/月份"
          prop="time"
        ></el-table-column>
        <el-table-column
          align="center"
          label="下载量"
          prop="down"
        ></el-table-column>
        <el-table-column
          align="center"
          label="新用户"
          prop="new_user"
        ></el-table-column>
        <el-table-column
          align="center"
          label="活跃用户"
          prop="dau"
        ></el-table-column>
        <el-table-column
          align="center"
          label="启动次数"
          prop="start_number"
        ></el-table-column>
        <el-table-column
          align="center"
          label="留存率"
          prop="dru"
        ></el-table-column>
        <el-table-column
          align="center"
          label="注册用户"
          prop="register_user"
        ></el-table-column>
        <!-- <el-table-column align="center" :label="timeType==='day'?'日活':'月活'" prop="ac"></el-table-column>
            <el-table-column align="center" :label="timeType==='day'?'日留存':'月留存'" prop="pr"></el-table-column> -->
      </el-table>
    </div>
  </div>
</template>
<script>
const start = new Date();
const end = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
const startTime = dateFormat(start);
const endTime = dateFormat(end);

/**
 * 返回格式化的时间
 * @param {Date} date 当前需要格式化的时间对象
 * @param {Strin} fmt 日期格式
 */
function getYear(date, isTime, onlyTime) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let time = year + "-" + get0(month) + "-" + get0(day);
  if (isTime) {
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (onlyTime) {
      time = get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    } else {
      time += " " + get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    }
  }

  return time;
}
function get0(num) {
  return num < 10 ? "0" + num : num;
}
function dateFormat(date, fmt) {
  fmt = fmt || "yyyy-mm-dd";
  const opt = {
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      date
        .getFullYear()
        .toString()
        .substr(4 - RegExp.$1.length)
    );
  }
  for (var k in opt) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? opt[k]
          : ("00" + opt[k]).substr(("" + opt[k]).length)
      );
    }
  }
  return fmt;
}
function weekFormat(date){
    let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let time=getMonthWeek(year,month,day)
  return time.getYear+'年'+time.getMonth+'月第'+time.getWeek+'周'
}

function getMonthWeek(a, b, c) {
  /**
   * a = d = 当前日期
   * b = 6 - w = 当前周的还有几天过完(不算今天)
   * a + b 的和在除以7 就是当天是当前月份的第几周
   */
  var date = new Date(a, parseInt(b) - 1, c),
    w = date.getDay(),
    d = date.getDate();
  if (w == 0) {
    w = 7;
  }
  var config = {
    getMonth: date.getMonth() + 1,
    getYear: date.getFullYear(),
    getWeek: Math.ceil((d + 6 - w) / 7),
  };
  return config;
}
// function getWeek(date){
//      let year = date.getFullYear();
//   let month = date.getMonth() + 1;
// //   let day = date.getDate();
//   let weekArray=getWeekData(year,month)
//   return weekArray

// }

// 时间日期面板
function dateTypeSelet(type) {
  let dateType = {
    daterange: [
      {
        text: "不限",
        onClick(picker) {
          picker.$emit("pick", ["", ""]);
        },
      },
      {
        text: "一天内",
        onClick(picker) {
          const start = new Date();
          picker.$emit("pick", [start, start]);
        },
      },
      {
        text: "7天内",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "30天内",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "一年内",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
    monthrange: [
      {
        text: "不限",
        onClick(picker) {
          picker.$emit("pick", ["", ""]);
        },
      },
      {
        text: "上个月",
        onClick(picker) {
          const start = new Date();
          start.setMonth(start.getMonth() - 1);
          picker.$emit("pick", [start, start]);
        },
      },
      {
        text: "近3个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 3);
          end.setMonth(end.getMonth() - 1);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "近12个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 12);
          end.setMonth(end.getMonth() - 1);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  return dateType[type] || [];
}

function getWeekData(year, month) {
  //传入  年  月  获取当月有几周 以及日期
  var new_year = year; //取当前的年份
  var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
  if (new_month < 10) {
    new_month = "0" + new_month;
  }
  var weekDay = [
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
    "星期天",
  ];
  if (new_month > 12) {
    new_month -= 12; //月份减
    new_year++; //年份增
  }
  var first_date = new Date(new_year, new_month, 1); //取当年当月中的第一天-时间格式
  var last_Data = new Date(
    first_date.getTime() - 1000 * 60 * 60 * 24
  ).getDate(); //获取当月最后一天日期
  //当月第一天是周几
  var firstzhouji =
    new Date(new_year + "/" + new_month + "/" + 1).getDay() == 0
      ? "星期天"
      : weekDay[new Date(new_year + "/" + new_month + "/" + 1).getDay() - 1];
  //当月最后一天是周几
  var lastzhouji =
    new Date(new_year + "/" + new_month + "/" + last_Data).getDay() == 0
      ? "星期天"
      : weekDay[
          new Date(new_year + "/" + new_month + "/" + last_Data).getDay() - 1
        ];
  var firsttime = ""; //第一周有几天
  if (firstzhouji == "星期一") {
    firsttime = 7;
  }
  if (firstzhouji == "星期二") {
    firsttime = 6;
  }
  if (firstzhouji == "星期三") {
    firsttime = 5;
  }
  if (firstzhouji == "星期四") {
    firsttime = 4;
  }
  if (firstzhouji == "星期五") {
    firsttime = 3;
  }
  if (firstzhouji == "星期六") {
    firsttime = 2;
  }
  if (firstzhouji == "星期天") {
    firsttime = 1;
  }

  var lasttime = ""; //最后一周有几天
  if (lastzhouji == "星期一") {
    lasttime = 1;
  }
  if (lastzhouji == "星期二") {
    lasttime = 2;
  }
  if (lastzhouji == "星期三") {
    lasttime = 3;
  }
  if (lastzhouji == "星期四") {
    lasttime = 4;
  }
  if (lastzhouji == "星期五") {
    lasttime = 5;
  }
  if (lastzhouji == "星期六") {
    lasttime = 6;
  }
  if (lastzhouji == "星期天") {
    lasttime = 7;
  }

  // 前后两周  加上 剩余周数  得出总周数
  var contime = 2 + (last_Data - lasttime - firsttime) / 7;

  //得出每周对应的日期
  var zhouArry = [];

  for (var i = 1; i <= contime; i++) {
    var strTime = "";
    var lastTime = "";
    if (i == 1) {
      strTime = year + "-" + new_month + "-" + "01";
      let aa = 1 + firsttime - 1;
      if (aa < 10) {
        aa = "0" + aa;
      }
      lastTime = year + "-" + new_month + "-" + aa;
    } else if (i == contime) {
      let bb = last_Data - lasttime + 1;
      if (bb < 10) {
        bb = "0" + bb;
      }
      strTime = year + "-" + new_month + "-" + bb;
      lastTime =
        year +
        "-" +
        new_month +
        "-" +
        (last_Data < 10 ? "0" + last_Data : last_Data);
    } else {
      strTime = addDate(zhouArry[zhouArry.length - 1].endTime, 1);
      lastTime = addDate(zhouArry[zhouArry.length - 1].endTime, 7);
    }
    let name = year + "年" + new_month + "月第" + i + "周";
    zhouArry.push({
      weeknum: i,
      beginTime: strTime,
      endTime: lastTime,
      name: name,
    });
  }
  return zhouArry;
}

//日期增加 接受两个参数， 传入的时间，传入时间增加的天数
function addDate(date, days) {
  if (days == undefined || days == "") {
    days = 1;
  }
  var date1 = new Date(date);
  date1.setDate(date1.getDate() + days);
  var month = date1.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  var day = date1.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return date1.getFullYear() + "-" + month + "-" + day;
}
// 获取选择日期所在周的周一和周日的时间
function getMondaySunday(date) {
  var now = new Date(date);
  var nowTime = now.getTime();
  var day = now.getDay();
  var oneDayTime = 24 * 60 * 60 * 1000;
  //显示周一
  var MondayTime = nowTime - (day - 1) * oneDayTime;
  //显示周日
  var SundayTime = nowTime + (7 - day) * oneDayTime;
  //初始化日期时间
  var monday = new Date(MondayTime);
  var sunday = new Date(SundayTime);
  let mondaysunday = { monday: format(monday), sunday: format(sunday) };
  return mondaysunday;
}
function add0(m) {
  return m < 10 ? "0" + m : m;
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  //var h = time.getHours();
  //var mm = time.getMinutes();
  //var s = time.getSeconds();
  return y + "-" + add0(m) + "-" + add0(d);
  //return y+''+add0(m)+''+add0(d)+''+add0(h)+':'+add0(mm)+':'+add0(s);
}

import Echarts from "echarts";
// // 引入组件库全局样式资源
export default {
  data() {
    return {
      dataSet: {},
      showWeek: false,
      showWeekPickerBox: false,
      activeType: "down", //选中的访问类型
      year: "",
      month: "",
      week: 0,
      weekArray: [],
      choosedWeeks: [],
      weekLable:[],
      types: [],
      typesBefore: [
        {
          id: "down",
          name: "下载量",
        },
        {
          id: "start_number",
          name: "启动次数",
        },
        {
          id: "new_user",
          name: "新用户",
        },
        {
          id: "register_user",
          name: "注册用户",
        },
      ],
      typesAfter: {
        day: [
          {
            id: "dau",
            name: "日活",
          },
          {
            id: "dru",
            name: "日留存",
          },
        ],
        month: [
          {
            id: "mau",
            name: "月活跃",
          },
          {
            id: "mru",
            name: "月留存",
          },
        ],
      },
      // 日数据和月数据
      timeType: "day",
      timeTypes: [
        {
          id: "day",
          name: "每日数据",
        },
        {
          id: "week",
          name: "每周数据",
        },
        {
          id: "month",
          name: "每月数据",
        },
      ],
      date: [],
      dateSeletd: "daterange",
      // 时间选择器配置
      pickerOptions: {},
      tableData: [],
    };
  },
  computed: {
    /**
     * 返回当前数据获取类型
     */
    getTimeType() {
      if (this.date[0] && this.date[0] === this.date[1]) {
        return "hour";
      }
      return "day";
    },
    //    getmonth () {
    //         return this.month
    //     }
  },
  created() {
    this.types = this.typesBefore.concat(...this.typesAfter[this.timeType]);
    this.pickerOptions.shortcuts = dateTypeSelet(this.dateSeletd);
    this.date = [startTime, endTime];

    const Loading = this.$loading();
    Promise.all([
      this.getAppCountAllData(false),
      this.getChartData(false),
      this.getTableData(false),
    ]).finally(() => {
      Loading.close();
    });
  },

  methods: {
    openWeekPicker() {
      this.showWeekPickerBox = !this.showWeekPickerBox;
      this.weekArray.forEach(item=>{
        item.active=false
      })
      this.choosedWeeks=[]
    },
    changeDate(type) {
      let month = this.month;
      if (type == "increaseMonth") {
        if (month < 12) {
          this.month = month + 1;
        }
      }
      if (type == "decreaseMonth") {
        if (month > 1) {
          this.month = month - 1;
        }
      }
      if (type == "increaseYear") {
        this.year += 1;
      }
      if (type == "decreaseYear") {
        this.year -= 1;
      }
      let weekArray = getWeekData(this.year, this.month);
      let choosedWeeks = this.choosedWeeks;
      weekArray.forEach((item) => {
        const res = choosedWeeks.findIndex((ev) => {
          return ev.beginTime === item.beginTime;
        });
        if (res !== -1) {
          item.active = true;
        }
      });

      this.weekArray = weekArray;
    },
    chooseWeek(index) {
      let weekArray = this.weekArray;
      let choosedWeeks = this.choosedWeeks;
      weekArray.forEach((item, i) => {
        if (i == index) {
          item.active = !item.active;
          if (item.active == true) {
            let res = choosedWeeks.findIndex((ev) => {
              return ev.beginTime === item.beginTime;
            });
            if (res === -1) {
              this.choosedWeeks.push(item);
            }
          } else {
            let res = choosedWeeks.findIndex((ev) => {
              return ev.beginTime === item.beginTime;
            });
            if (res !== -1) {
              this.choosedWeeks.splice(res, 1);
            }
          }
        }
      });
      this.choosedWeeks.sort(
        (a, b) => new Date(a.beginTime) - new Date(b.beginTime)
      );
      console.log(getMondaySunday(this.choosedWeeks[0].beginTime));
      this.weekArray = JSON.parse(JSON.stringify(weekArray));
      console.log("active", this.weekArray, this.choosedWeeks);
    },
    quickChose(type){
      if (type==1){
               let time=new Date()
        time.setTime(time.getTime() - 3600 * 1000 * 24 * 7);
        let name= weekFormat(time)
          time= dateFormat(time)
          let week={beginTime:time,name:name}
          this.choosedWeeks.push(week)
          
      }
      if(type==12||type==3){
        let start=new Date()
        let end=new Date()
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7*(type-1));
        end.setTime(end.getTime())
          start= dateFormat(start)
           end= dateFormat(end)
          let startWeek={beginTime:start}
          let endWeek={beginTime:end}
          this.choosedWeeks.push(startWeek,endWeek)
      }
      this.refreshPageDate()
    },
    pick(e) {
      var date = new Date(e);
      console.log(e);
      // 有三种方式获取
      var time1 = date.getTime();
      console.log(time1);
    },
    // 获取头部数据
    getAppCountAllData(load = true) {
      return this.$ajax(
        "/web/app_count_all_new",
        {},
        {
          method: "get",
          load,
        }
      ).then((data) => {
        this.dataSet = data.data;
      });
    },

    // 获取图表部分数据
    async getChartData(load = true) {
      let startTime = this.date[0] ? this.date[0] + "T00:00:00.000+0800" : "";
      let endTime = this.date[1] ? this.date[1] + "T23:59:59.999+0800" : "";
      let timeType = this.timeType;
      let y1 = [];
      if (this.timeType == "day") {
        // 如果是一天范围内，则还需要取前一天的数据
        if (this.date[0] && this.date[0] === this.date[1]) {
          startTime = this.date[0] + "T00:00:00.000+0800";
          endTime = this.date[0] + "T23:59:59.999+0800";
          timeType = "hour";
          let time = new Date(this.date[0]);
          time.setTime(time.getTime() - 3600 * 1000 * 24);
          let date = getYear(time);
          let prevStartTime = date + "T00:00:00.000+0800";
          let prevEndTime = date + "T23:59:59.999+0800";
          let prevDate = await this.$ajax(
            `/web/app_count_${this.activeType}_by_${timeType}_new`,
            {
              startTime: prevStartTime,
              endTime: prevEndTime,
            },
            {
              method: "get",
              load,
            }
          );
          prevDate.data.forEach((item) => {
            y1.push(item.value);
          });
        }
      }
      if (this.timeType == "month") {
        if (this.date[0]) {
          const startDay = new Date(this.date[0]);
          startDay.setDate(1);
          startTime = dateFormat(startDay) + "T00:00:00.000+0800";
        }

        if (this.date[1]) {
          const endDay = new Date(this.date[1]);
          endTime =
            dateFormat(
              new Date(
                +new Date(
                  endDay.getFullYear() + "-" + (endDay.getMonth() + 2) + "-1"
                ) - 1
              )
            ) + "T23:59:59.999+0800";
        }
      }
      if (this.timeType == "week") {
        let monday;
        let sunday;
        let choosedWeeks = this.choosedWeeks;
        if (choosedWeeks.length == 1) {
          monday = getMondaySunday(this.choosedWeeks[0].beginTime).monday;
          sunday = getMondaySunday(this.choosedWeeks[0].beginTime).sunday;
        } else {
          monday = getMondaySunday(this.choosedWeeks[0].beginTime).monday;
          sunday = getMondaySunday(
            this.choosedWeeks[choosedWeeks.length - 1].beginTime
          ).sunday;
        }
        startTime = monday + "T00:00:00.000+0800";
        endTime = sunday + "T23:59:59.999+0800";
      }
      return this.$ajax(
        `/web/app_count_${this.activeType}_by_${timeType}_new`,
        {
          startTime,
          endTime,
        },
        {
          method: "get",
          load,
        }
      ).then((data) => {
        if (this.timeType==='day'&& this.date[0] && this.date[0] === this.date[1]) {
          this.formatChartData(data.data, y1);
        } else if (this.timeType == "week") {
                      let x = [];
          if (this.choosedWeeks.length == 1) {
            x.push(this.choosedWeeks[0].name);
            this.formatChartData(data.data, x);
          } else {
            data.data.forEach(item=>{
              let time = new Date(item.name);
              let week= weekFormat(time)
              x.push(week)
            })
            this.formatChartData(data.data,x);
          }
        } else {
          this.formatChartData(data.data);
        }
      });
    },
    // 获取表格部分的数据
    getTableData(load = true) {
      let startTime = this.date[0] ? this.date[0] + "T00:00:00.000+0800" : "";
      let endTime = this.date[1] ? this.date[1] + "T23:59:59.999+0800" : "";
      let timeType = this.timeType;
      if (this.timeType == "month") {
        if (this.date[0]) {
          const startDay = new Date(this.date[0]);
          startDay.setDate(1);
          startTime = dateFormat(startDay) + "T00:00:00.000+0800";
        }
        if (this.date[1]) {
          const endDay = new Date(this.date[1]);
          endTime =
            dateFormat(
              new Date(
                +new Date(
                  endDay.getFullYear() + "-" + (endDay.getMonth() + 2) + "-1"
                ) - 1
              )
            ) + "T23:59:59.999+0800";
        }
      }
      if (this.timeType=='day'&&this.date[0] && this.date[0] === this.date[1]) {
        timeType = "hour";
      }
       if (this.timeType == "week") {
        let monday;
        let sunday;
        let choosedWeeks = this.choosedWeeks;
        if (choosedWeeks.length == 1) {
          monday = getMondaySunday(this.choosedWeeks[0].beginTime).monday;
          sunday = getMondaySunday(this.choosedWeeks[0].beginTime).sunday;
        } else {
          monday = getMondaySunday(this.choosedWeeks[0].beginTime).monday;
          sunday = getMondaySunday(
            this.choosedWeeks[choosedWeeks.length - 1].beginTime
          ).sunday;
        }
        startTime = monday + "T00:00:00.000+0800";
        endTime = sunday + "T23:59:59.999+0800";
      }
      this.$ajax(
        `/web/app_all_count_by_new_${timeType}`,
        {
          startTime,
          endTime,
        },
        {
          method: "get",
          load,
        }
      ).then((data) => {
        let res = data.data;
        let table = [];
        // let acType = "";
        // let prType = ""
        // if(this.timeType === "day"){
        //     acType = "dau";
        //     prType = "dru";
        // }else{
        //     acType = "mau";
        //     prType = "mru";
        // }
        res.down.forEach((item, index) => {
          let time = new Date(item.name);
          let dru
        if(res.new_user[index].value==0){
           dru=0
          }else{
             dru=((parseFloat(res.dru[index].value/res.new_user[index].value))*10).toFixed(2)+'%'
          }
          if (this.timeType === "day") {
            if (this.date[0] && this.date[0] === this.date[1]) {
              time.setTime(time.getTime() - 3600 * 1000 * 8);
              time = getYear(time, true);
            } else {
              time = dateFormat(time);
            }
          } else if(this.timeType=='week'){
            if(res.down.length==1){
time=this.weekLable[0]
            }else{
             time= weekFormat(time)
            }
          }else {
            time = dateFormat(time, "yyyy-mm");
          }
          table.push({
            time: time,
            down: res.down[index].value,
            new_user: res.new_user[index].value,
            dau: res.dau[index].value,
            start_number: res.start_number[index].value,
            register_user: res.register_user[index].value,
            dru: dru
            // dru:res.dru[index].value/res.new_user[index].value
          });
        });
                this.tableData = table.reverse();
            if (this.timeType==='day'&&this.date[0] && this.date[0] === this.date[1]) {
              this.tableData=table.reverse()
            }
            if(this.timeType==='week'){
              this.tableData=table.reverse()
            }
            
      });
    },

    // 更新页面数据
    refreshPageDate() {
      const Loading = this.$loading();
      Promise.all([this.getChartData(false), this.getTableData(false)]).finally(
        () => {
          Loading.close();
        }
      );
    },

    // 天和月选项切换
    changeDM(val) {
      if (val === "month") {
        this.showWeek = false;
        if (this.dateSeletd === "monthrange") return;
        this.dateSeletd = "monthrange";
        this.pickerOptions.shortcuts = dateTypeSelet(this.dateSeletd);
        const start = new Date();
        const end = new Date();
        start.setMonth(start.getMonth() - 3);
        end.setMonth(end.getMonth() - 1);
        this.date = [dateFormat(start), dateFormat(end)];
      } else if (val === "week") {
        this.dateSeletd = "weekrange";
        this.showWeek = true;
        let time = new Date();
        time.setTime(time.getTime());
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        this.year = year;
        this.month = month;
        let weekArray = getWeekData(year, month);
        this.weekArray = weekArray;
        var getDate = getMonthWeek(year, month, day);
        this.week = getDate.getWeek;
        weekArray.forEach((item) => {
          if (item.weeknum == getDate.getWeek) {
            item.active = true;
            let index = this.choosedWeeks.findIndex((ev) => {
              return ev.beginTime === item.beginTime;
            });
            if (index == -1) {
              this.choosedWeeks.push(item);
            }
          }
        });
                this.refreshPageDate();
      } else {
        this.showWeek = false;
        if (this.dateSeletd === "daterange") return;
        this.dateSeletd = "daterange";
        this.pickerOptions.shortcuts = dateTypeSelet(this.dateSeletd);
        this.date = [startTime, endTime];
      }
      if (
        this.activeType == "dau" ||
        this.activeType == "dru" ||
        this.activeType == "mau" ||
        this.activeType == "mru"
      ) {
        this.activeType = "down";
      }
      if(this.timeType=='week'){
this.types = this.typesBefore
      }else{
      this.types = this.typesBefore.concat(...this.typesAfter[this.timeType]);
      }
      this.refreshPageDate();
    },

    // 格式化图表的数据
    formatChartData(data, y1) {
      let x = [];
      let y = [];
      if (this.timeType==='day'&&this.date[0] && this.date[0] === this.date[1]) {
        data.forEach((item) => {
          let date = new Date(item.name);
          date.setTime(date.getTime() - 3600 * 1000 * 8);
          let time = getYear(date, true, true);

          x.push(time);
          // let date = new Date(item.name);
          // date.setTime(date.getTime() - 3600 * 1000 * 8);
          // let time = dateFormat(date,this.timeType==="month"?"yyyy-mm":"")
          // x.push(time)
          y.push(item.value);
        });
        this.initEcharts(x, y, y1);
      } else if (this.timeType === "week") {
        data.forEach((item) => {
          y.push(item.value);
        });
        this.initEcharts(y1, y);
        this.weekLable=y1
        console.log('weeklable',this.weekLable)

      } else {
        data.forEach((item) => {
          let date = new Date(item.name);
          date.setTime(date.getTime() - 3600 * 1000 * 8);
          let time = dateFormat(
            date,
            this.timeType === "month" ? "yyyy-mm" : ""
          );
          x.push(time);
          y.push(item.value);
        });
        this.initEcharts(x, y);
      }
    },

    // 初始化图表
    initEcharts(x = [], y = [], y1 = []) {
      let Chart = Echarts.init(this.$refs.echarts);
      var legendDatas = [];
      if (this.timeType === "month") {
        legendDatas = ["今年", "去年"];
      } else {
        legendDatas = ["当日", "前一日"];
      }
      let option = {
        xAxis: {
          type: "category",
          data: x,
        },
        yAxis: {
          type: "value",
        },
        legend: {
          data: legendDatas,
        },
        series: [
          {
            name: legendDatas[0],
            data: y,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#00CCFF",
              },
            },
            lineStyle: {
              normal: {
                color: "#00CCFF",
              },
            },
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#00CCFF",
              },
            },
          },
          {
            name: legendDatas[1],
            data: y1,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#FFCC66",
              },
            },
            lineStyle: {
              normal: {
                color: "#FFCC66",
              },
            },
            label: {
              normal: {
                show: true,
                position: "bottom",
                color: "#FFCC66",
              },
            },
          },
        ],
      };
      option.legend.show = y1.length > 0;
      Chart.setOption(option);
      window.onresize = Chart.resize;
                          this.showWeekPickerBox=false
    },
    getTime(e) {
      // this.startDate = e[0].start;
      // this.endDate = e[1].end;
      const myDate = new Date(e[1].end);
      const year = myDate.getFullYear();
      const month = ("0" + (myDate.getMonth() + 1)).slice(-2);
      const day = ("0" + myDate.getDate()).slice(-2);
      let LastDate = new Date(e[0].start);
      const lastyear = LastDate.getFullYear();
      const lastmonth = ("0" + (LastDate.getMonth() + 1)).slice(-2);
      const lastday = ("0" + LastDate.getDate()).slice(-2);
      this.startDate = `${lastyear}-${lastmonth}-${lastday}`;
      this.endDate = `${year}-${month}-${day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-item {
  border: 1px solid #f4f5f9;
  .content-item__title {
    background: #f4f5f9;
    padding: 10px 20px;
  }
  .content-item_info {
    padding: 25px 0;
  }
  .content-item__echarts {
    height: 500px;
  }
}
.flex-w__2 {
  flex: 2;
  width: 100%;
}
.weekPicker {
  height: 32px;
  border: 1px solid #dcdfe6;
  background-color: white;
  display: flex;
  align-items: center;
  line-height: 32px;
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
    padding-right: 10px;
}
.weekPickerBox {
  width: 360px;
  height: 150px;
  border: 1px solid #dcdfe6;
  background-color: white;
   position: absolute;
    top: 52px;
    left: 380px;
  z-index: 1000;
  display: flex;
  .leftBox {
    line-height: 28px;
    font-size: 14px;
    width: 90px;
    color: #606266;
    padding: 0 12px;
    text-align: left;
    border-right: 1px solid #dcdfe6;
  }
  .rightBox {
    width: 290px;
    .year {
      display: flex;
      margin-top: 10px;
      padding-right: 18px;
      padding-left: 18px;
      .yearmonth {
        font-size: 14px;
        margin: -4px 18px 0;
        text-align: center;
      }
      .shuangarrow {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
      .arrow {
        margin-left: 22px;
        margin-right: 22px;
        width: 8px;
        height: 10px;
        cursor: pointer;
      }
    }
    .week {
      display: flex;
      flex-wrap: wrap;
      margin-left: 7px;
      margin-top: 10px;
      .activeWeek {
        cursor: pointer;
        line-height: 28px;
        font-size: 15px;
        color: #409eff;
        padding: 0 13px;
        width: 65px;
      }
      .weekArray {
        cursor: pointer;
        line-height: 28px;
        font-size: 15px;
        color: #606266;
        padding: 0 13px;
        width: 65px;
      }
    }
  }
}
</style>
